import { faLayerGroup } from '@fortawesome/pro-regular-svg-icons';

import { PRESENCE_STATES } from 'lib/common/constants/presenceStates';

import { getInteractionsTooltipProps } from 'lib/common/utils/getInteractionsTooltipProps';

import Icon from '../../Icon';
import Text from '../../Text';
import { Colour } from '../../Text/types';
import { Divider } from '../../atoms/Divider';
import { TContactListData } from '../Directory/hooks/usePaginatedLoad';
import PresenceBadge from '../PresenceBadge';

import styles from './availability-interactions-tooltip.module.scss';

export default function AvailabilityInteractionsTooltip({
  onContact,
  visibleAgentPresence,
}: {
  onContact: TContactListData['onContact'] | undefined;
  visibleAgentPresence: PRESENCE_STATES;
}) {
  const { text, iconColor, textColor } = getInteractionsTooltipProps(onContact);

  return (
    <div className={styles['availability-interactions-tooltip__container']}>
      <PresenceBadge presence={visibleAgentPresence} />
      <Divider height={25} color="midGrey" />
      <Icon size={15} icon={faLayerGroup} color={iconColor} />
      <Text color={textColor as Colour}>{text}</Text>
    </div>
  );
}
